import React, {useState} from 'react';
import styles from './MyTeam.module.scss';
import {Loader} from "../Loader/Loader";
import {useUserSearch} from "../Hooks/UseUserSearch";
import cross_img from "../../../../assets/img/cross_img.svg"

const UserSearchInput = ({
                             searchQuery,
                             setSearchQuery,
                             selectUser,
                             setSelectUser,
                             placeholder
                         }) => {
    const [isListOpen, setIsListOpen] = useState(false);

    const {
        loading,
        searchResults,
        isSearchPerformed,
        debouncedFetchData
    } = useUserSearch();

    const handleSearchChange = (event) => {
        const searchValue = event.target.value;
        setSearchQuery(searchValue);
        setSelectUser("");
        if (searchValue.trim().length > 0) {
            setIsListOpen(true);
            debouncedFetchData(searchValue);
        } else {
            setIsListOpen(false);
        }
    };

    const handleItemClick = (name) => {
        setSelectUser(name);
        setSearchQuery(name);
        setIsListOpen(false);
    };

    const clearQuery = () => {
        setSearchQuery("")
        setSelectUser("");
        setIsListOpen(false);
    }

    return (
        <>
            <input
                value={selectUser ? selectUser : searchQuery}
                onChange={handleSearchChange}
                className={styles.teamInput}
                placeholder={placeholder}
            />
            {
                searchQuery &&
                <button
                    onClick={clearQuery}
                    className={styles.deleteUserBtn}
                >
                    <img src={cross_img} alt={""}/>
                </button>
            }
            {isListOpen && (
                <div className={styles.searchContainer}>
                    {loading ? (
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            paddingTop: "30px"
                        }}>
                            <Loader/>
                        </div>
                    ) : (
                        <>
                            {searchResults.length > 0 ? (
                                <ul>
                                    {searchResults.map(result => (
                                        <li
                                            className={styles.userListItem}
                                            onClick={() => handleItemClick(result)}
                                            key={result.id}
                                        >
                                            {result.name}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                isSearchPerformed && <p style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    paddingTop: "15px"
                                }}>
                                    Пользователи не найдены
                                </p>
                            )}
                        </>
                    )}
                </div>
            )}
        </>
    );
};

export {UserSearchInput};